import React, { useRef, useEffect } from "react";

import Loading from "components/Loading";
import TableRow from "../TableRow";

import classes from "./styles.module.scss";

const TableBody = ({ transactions, fetchMoreTransactions, lazyLoadData, loading }) => {
    const loaderRef = useRef();

    const { isLoading: isLoadingMore, lastId = null, hasMore = false } = lazyLoadData;

    useEffect(() => {
        if (!loaderRef.current) return;
        if (!hasMore || loading || isLoadingMore) return;

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                fetchMoreTransactions(true);
            }
        });

        observer.observe(loaderRef.current);
        return () => observer.disconnect();
    }, [loading, hasMore, isLoadingMore]);

    if (loading && !isLoadingMore) {
        return <Loading message="Loading transactions..." styles={{ marginTop: "10px" }} />;
    }

    if (!transactions || (transactions.length === 0 && !loading)) {
        return (
            <div className={classes.emptyTransactionContainer}>
                <h3>You have no transactions.</h3>
            </div>
        );
    }

    return (
        <div>
            {transactions &&
                transactions.map((transaction) => <TableRow key={transaction.id} transaction={transaction} />)}
            {isLoadingMore && <Loading message="Loading more transactions..." styles={{ marginTop: "10px" }} />}
            {hasMore && !isLoadingMore && <div ref={loaderRef} style={{ height: "30px" }} />}
        </div>
    );
};

export default TableBody;
